<template>
  <div class="transfer">
    <v-app>
      <div v-if="!userid">
        <v-container>
          <v-alert :value="true" color="warning" icon="priority_high" outline>
            {{ $t('Not found this page') }}
          </v-alert>
        </v-container>
      </div>
      <div v-else-if="isCompleted">
        <cover>
          <div slot="body" style="text-align: center; margin-top: -95px">
            <img
              src="@/assets/img/ecommerce/shopping_cart@4x.png"
              alt="shopping cart"
              style="width: 140px; padding-bottom: 10px"
            />
            <p style="padding-bottom: 10px">{{ $t('Payment Successfully') }}</p>
            <v-btn outline :color="theme.color" @click="goToShop()">
              {{ $t('Continue Shopping') }}
            </v-btn>
          </div>
        </cover>
      </div>
      <div v-else-if="isEmptyShoppingCart">
        <cover>
          <div slot="body" style="text-align: center; margin-top: -95px">
            <img
              src="@/assets/img/ecommerce/shopping_cart_out@4x.png"
              alt="empty shopping cart"
              style="width: 140px; padding-bottom: 10px"
            />
            <p style="padding-bottom: 10px">
              {{ $t('This order has been reset, please try to order again.') }}
            </p>

            <v-btn outline :color="theme.color" @click="goToShop()">
              {{ $t('Continue Shopping') }}
            </v-btn>
          </div>
        </cover>
      </div>
      <div v-else>
        <merchant-detail v-model="pageProfile"></merchant-detail>

        <form
          id="checkout-form"
          class="checkout-form"
          method="POST"
          @submit.prevent="handleSubmit"
        >
          <v-container class="mt-5">
            <v-layout wrap row>
              <v-flex xs12 sm6 offset-sm3>
                <h3 class="headline" :style="{ color: theme.color }">
                  {{ $t('Payment') }}
                </h3>

                <br />
              </v-flex>
              <v-flex xs12 sm6 offset-sm3>
                <div
                  :class="{ 'has-error': errors.has('customerName') }"
                  class="mb-1"
                >
                  <v-text-field
                    :label="$t('Name')"
                    :data-vv-as="$t('Name')"
                    outline
                    name="customerName"
                    v-validate="'required'"
                    v-model="customerName"
                    light
                    :color="theme.color"
                    :error="errors.has('customerName') ? true : false"
                    :error-messages="
                      errors.has('customerName')
                        ? errors.first('customerName')
                        : ''
                    "
                  ></v-text-field>
                </div>
                <template v-if="chooseShippingType == 'delivery'">
                  <div
                    :class="{ 'has-error': errors.has('shippingAddress') }"
                    class="mb-1"
                  >
                    <div class="mb-3">
                      <div
                        :class="{ 'has-error': errors.has('ปักหมุดที่อยู่') }"
                        class="mb-1"
                      >
                        <gmap-address
                          v-if="showmap"
                          :showRadius="false"
                          :placesinfo="placesinfolabel"
                          v-validate="{ required: true }"
                          name="ปักหมุดที่อยู่"
                          v-model="gmapvalue"
                          v-on:input="gmapLocation"
                          :lastordercoords="lastordercoords"
                          :error="errors.has('ปักหมุดที่อยู่')"
                          :shoplocation="branchlocation"
                          :radius="20000"
                          :radiusColor="theme.color"
                        ></gmap-address>
                        <p
                          class="caption ma-2"
                          style="color: red"
                          v-show="errors.has('ปักหมุดที่อยู่')"
                        >
                          {{ errors.first('ปักหมุดที่อยู่') }}
                        </p>
                      </div>
                    </div>
                    <v-textarea
                      outline
                      :label="$t('Shipping Address')"
                      :placeholder="
                        $t('Ex. Address No., Village, Alley, and Road')
                      "
                      name="shippingAddress"
                      rows="5"
                      :data-vv-as="$t('Shipping Address')"
                      style="resize: none; width: 100%"
                      v-model="shippingAddress"
                      v-validate="{
                        required: true,
                        regex: /([^0-9][1-9][0-9]{4})|^([1-9][0-9]{4})/,
                        isBearhousezipcode: [cart.length, isBearhouse]
                      }"
                      light
                      :color="theme.color"
                      :error="errors.has('shippingAddress') ? true : false"
                      :error-messages="
                        errors.has('shippingAddress')
                          ? errors.first('shippingAddress')
                          : ''
                      "
                    ></v-textarea>
                  </div>
                </template>

                <div
                  :class="{ 'has-error': errors.has('customerPhone') }"
                  class="mb-1"
                >
                  <v-text-field
                    :label="$t('Tel.')"
                    :data-vv-as="$t('Tel.')"
                    outline
                    tyle="tel"
                    name="customerPhone"
                    light
                    :color="theme.color"
                    v-validate="{
                      required: true,
                      regex:
                        /((\(?(\+\s*)([0-9]{2,3})\)?\s*[0]?)|[0])(([1-9][0-9]?))\s*\-?\s*([0-9]{3})\s*\-?\s*([0-9]{4,5})/
                    }"
                    v-model="customerPhone"
                    :error="errors.has('customerPhone') ? true : false"
                    :error-messages="
                      errors.has('customerPhone')
                        ? errors.first('customerPhone')
                        : ''
                    "
                  ></v-text-field>
                </div>

                <template
                  v-if="
                    pageProfile && pageProfile.pageid && shippinglist && !isOoca
                  "
                >
                  <shipping-type
                    :bearhouseshippingprice="bearhouseshippingprice"
                    :customerShippingPrice="customShippingPrice"
                    v-model="shippingType"
                    :shippinglist="shippinglist"
                    :additionalproduct_charge="additionalproduct_charge"
                    :pageid="pageProfile.pageid"
                    :total="totalincludediscount"
                  ></shipping-type>
                </template>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
          <v-container class="mt-3">
            <v-layout wrap row>
              <v-flex xs12 sm6 offset-sm3>
                <h3 class="headline mb-3" :style="{ color: theme.color }">
                  {{ $t('Payment Detail') }}
                </h3>

                <cart-summary
                  :total="total"
                  :totalincludediscount="totalPrice"
                  :isCustomize="true"
                  :discount="discount"
                  :shippingType="shippingType"
                  :additionalproduct_charge="additionalproduct_charge"
                  :customerShippingPrice="customShippingPrice"
                  :ableToBuy="ableToBuy"
                ></cart-summary>
                <div v-if="['transfer', 'fbpay'].includes(transferType)">
                  <div class="mb-4">
                    <template v-if="banktransferinfo_photo">
                      <img
                        :src="banktransferinfo_photo"
                        alt="bank transfer"
                        style="
                          border: 1px solid #eee;
                          border-radius: 5px;
                          margin-bottom: 15px;
                          width: 100%;
                        "
                      />
                    </template>
                    <template v-if="banktransferinfo">
                      <bank-number :text="banktransferinfo"></bank-number>
                    </template>
                  </div>
                  <template v-if="ableToBuy">
                    <div
                      :class="{ 'has-error': errors.has('paymentSlipImage') }"
                      class="mb-4"
                      v-if="
                        !shippingType ||
                        (shippingType && shippingType.type != 'cod_charge')
                      "
                    >
                      <h3 class="headline" :style="{ color: theme.color }">
                        {{ $t('Payment slip') }}
                      </h3>
                      <br />

                      <upload-file
                        name="paymentSlipImage"
                        v-validate="'required'"
                        :data-vv-as="$t('Payment Slip Image')"
                        v-model="paymentSlipImage"
                      ></upload-file>
                      <p
                        class="caption ma-2"
                        style="color: red"
                        v-show="errors.has('paymentSlipImage')"
                      >
                        {{ errors.first('paymentSlipImage') }}
                      </p>
                    </div>
                  </template>
                </div>

                <div
                  :class="{ 'has-error': errors.has('remark') }"
                  style="margin-bottom: 15px"
                >
                  <v-textarea
                    outline
                    :label="$t('Remark')"
                    name="remark"
                    rows="5"
                    :data-vv-as="$t('Remark')"
                    style="resize: none; width: 100%"
                    v-model="remark"
                    :color="theme.color"
                    light
                  ></v-textarea>
                </div>
                <div>
                  <div
                    v-if="
                      pageProfile.fbpay_status ||
                      (pageProfile.gbprime_status && !isOoca)
                    "
                    style="padding-bottom: 25px"
                  >
                    <v-card>
                      <v-card-text>
                        <v-layout row wrap class="mb-3">
                          <v-flex class="pr-1" v-if="pageProfile.fbpay_status">
                            <v-btn
                              :color="theme.color"
                              dark
                              small
                              block
                              @click="transferType = 'fbpay'"
                              :outline="transferType != 'fbpay'"
                            >
                              <v-icon small class="mr-2"
                                >mdi-facebook-messenger</v-icon
                              >
                              {{ $t('Mobile Banking') }}
                            </v-btn>
                            <div
                              class="text-xs-center"
                              :style="{ color: theme.color }"
                            >
                              <!-- (รวดเร็วกว่า) -->
                            </div>
                          </v-flex>
                          <v-flex
                            class="pr-1"
                            v-if="pageProfile.gbprime_status"
                          >
                            <v-btn
                              :color="theme.color"
                              dark
                              block
                              small
                              @click="transferType = 'qrcode'"
                              :outline="transferType != 'qrcode'"
                            >
                              <v-icon small class="mr-2">mdi-qrcode-scan</v-icon
                              >QR CODE
                            </v-btn>
                            <div
                              class="text-xs-center"
                              :style="{ color: theme.color }"
                            >
                              <!-- (รวดเร็วกว่า) -->
                            </div>
                          </v-flex>
                          <v-flex>
                            <v-btn
                              :color="theme.color"
                              dark
                              block
                              small
                              @click="transferType = 'transfer'"
                              :outline="transferType != 'transfer'"
                            >
                              <v-icon small class="mr-2"
                                >mdi-cash-multiple</v-icon
                              >
                              {{ $t('transfer') }}
                            </v-btn>
                          </v-flex>
                        </v-layout>

                        <template
                          v-if="['transfer', 'fbpay'].includes(transferType)"
                        >
                          <div v-if="['transfer'].includes(transferType)">
                            <div class="mb-4">
                              <template v-if="banktransferinfo_photo">
                                <img
                                  :src="banktransferinfo_photo"
                                  alt="bank transfer"
                                  style="
                                    border: 1px solid #eee;
                                    border-radius: 5px;
                                    margin-bottom: 15px;
                                    width: 100%;
                                  "
                                />
                              </template>
                              <template v-if="banktransferinfo">
                                <bank-number
                                  :text="banktransferinfo"
                                ></bank-number>
                              </template>
                            </div>

                            <div
                              :class="{
                                'has-error': errors.has('paymentSlipImage')
                              }"
                              class="mb-4"
                              v-if="
                                !shippingType ||
                                (shippingType &&
                                  shippingType.type != 'cod_charge')
                              "
                            >
                              <h3
                                class="headline"
                                :style="{ color: theme.color }"
                              >
                                {{ $t('Payment slip') }}
                              </h3>
                              <br />

                              <upload-file
                                name="paymentSlipImage"
                                v-validate="'required'"
                                :data-vv-as="$t('Payment Slip Image')"
                                v-model="paymentSlipImage"
                              ></upload-file>
                              <p
                                class="caption ma-2"
                                style="color: red"
                                v-show="errors.has('paymentSlipImage')"
                              >
                                {{ errors.first('paymentSlipImage') }}
                              </p>
                            </div>
                          </div>

                          <div
                            class="text-xs-center"
                            style="padding-top: 15px; padding-bottom: 15px"
                          >
                            <a
                              href="javascript:void(0);"
                              @click="openModal()"
                              style="color: rgb(169, 169, 169)"
                            >
                              {{
                                $t('By clicking Proceed Payment, Ive read and')
                              }}
                              <br />
                              {{ $t('agree to') }}
                              <span :style="{ color: theme.color }">
                                {{
                                  $t('Terms & Condition & Refund Prolicy')
                                }} </span
                              >.
                            </a>
                          </div>
                          <p
                            class="text-xs-center"
                            style="color: red"
                            v-if="isEmptyShoppingCart"
                          >
                            {{
                              $t(
                                'Not enough products in stock, please try to order again.'
                              )
                            }}.
                          </p>
                          <div class="text-xs-center">
                            <v-btn
                              dark
                              :color="theme.color"
                              :disabled="loading || isEmptyShoppingCart"
                              @click="handleSubmit"
                              :loading="pageLoading"
                            >
                              <v-icon class="mr-2">mdi-cart-outline</v-icon>
                              {{ $t('Proceed Payment') }}
                            </v-btn>
                          </div>
                        </template>
                        <template v-else>
                          <div
                            class="text-xs-center"
                            style="padding-top: 15px; padding-bottom: 15px"
                          >
                            <a
                              href="javascript:void(0);"
                              @click="openModal()"
                              style="color: rgb(169, 169, 169)"
                            >
                              {{
                                $t('By clicking Proceed Payment, Ive read and')
                              }}
                              <br />
                              {{ $t('agree to') }}
                              <span :style="{ color: theme.color }">
                                {{
                                  $t('Terms & Condition & Refund Prolicy')
                                }} </span
                              >.
                            </a>
                          </div>
                          <p
                            class="text-xs-center"
                            style="color: red"
                            v-if="isEmptyShoppingCart"
                          >
                            {{
                              $t(
                                'Not enough products in stock, please try to order again.'
                              )
                            }}.
                          </p>
                          <p
                            v-else-if="!ableToBuy"
                            style="color: red"
                            class="text-xs-center"
                          >
                            ไม่สามารถจัดส่งนอกพื้นที่ได้
                          </p>

                          <div v-else class="text-xs-center">
                            <v-btn
                              dark
                              :color="theme.color"
                              :disabled="loading || isCartOutOfStock"
                              @click="qrHandleSubmit"
                              :loading="pageLoading || loadingQrcode"
                            >
                              <v-icon class="mr-2">mdi-cart-outline</v-icon>
                              {{ $t('Proceed Payment') }}
                            </v-btn>
                          </div>
                        </template>
                      </v-card-text>
                    </v-card>
                  </div>

                  <div
                    v-if="
                      !(pageProfile.fbpay_status || pageProfile.gbprime_status)
                    "
                    class="text-xs-center"
                    style="padding-bottom: 25px"
                  >
                    <div style="padding-top: 15px; padding-bottom: 15px">
                      <a
                        href="javascript:void(0);"
                        @click="openModal()"
                        style="color: rgb(169, 169, 169)"
                      >
                        {{ $t('By clicking Proceed Payment, Ive read and') }}
                        <br />
                        {{ $t('agree to') }}
                        <span :style="{ color: theme.color }">
                          {{ $t('Terms & Condition & Refund Prolicy') }} </span
                        >.
                      </a>
                    </div>
                    <p
                      class="text-xs-center"
                      style="color: red"
                      v-if="isEmptyShoppingCart"
                    >
                      {{
                        $t(
                          'Not enough products in stock, please try to order again.'
                        )
                      }}.
                    </p>
                    <p
                      v-else-if="!ableToBuy"
                      style="color: red"
                      class="text-xs-center"
                    >
                      ไม่สามารถจัดส่งนอกพื้นที่ได้
                    </p>
                    <v-btn
                      dark
                      v-else
                      :color="theme.color"
                      :disabled="loading || isEmptyShoppingCart"
                      @click="handleSubmit"
                      :loading="pageLoading"
                    >
                      <v-icon class="mr-2">mdi-cart-outline</v-icon>
                      {{ $t('Proceed Payment') }}
                    </v-btn>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </div>
    </v-app>
    <Loading v-if="!pageLoading && loading"></Loading>
    <term-and-condition v-if="showTerm" @close="close()"></term-and-condition>
    <v-dialog v-model="showQrCode" max-width="376" persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="closeQrCode">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <template v-if="qrimage">
            <img :src="qrimage" style="width: 100%" />
            <div class="text-xs-center mt-2">
              {{
                $t(
                  'If you already have proceeded a payment, you may close this popup window.'
                )
              }}
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import config from '@/config'
import axios from 'axios'
import MainTransfer from './MainTransfer'
import GmapAddress from '@/components/ecommerce/GmapAddress.vue'
export default {
  mixins: [MainTransfer],
  data() {
    return {
      shippingdistance: null,
      ableToShipping: true,
      customShippingFee: 0,
      chooseShippingType: 'delivery',
      lastordercoords: null,
      showmap: false,
      gmapvalue: null,
      placesinfo: null,
      fastdelishippingprice: null
    }
  },
  components: { GmapAddress },
  computed: {
    ableToBuy() {
      return this.ableToShipping
    },
    customShippingPrice() {
      return this.customShippingFee
    },
    placesinfolabel() {
      return (
        this.placesinfo +
        ` (${this.shippingdistance ? this.shippingdistance.distance : 0} Km)` +
        `<div style="margin-top: 5px;border-radius: 5px;padding: 5px; color: white; background: ${
          this.ableToBuy ? 'green' : 'red'
        }">${
          this.ableToBuy
            ? ` ค่าส่ง ${this.customShippingPrice} บาท`
            : ' ไม่สามารถจัดส่งได้'
        }</div>`
      )
    },
    totalPrice: function () {
      return (
        this.totalincludediscount +
        this.customShippingPrice +
        this.additionalproduct_charge
      )
    }
  },
  methods: {
    async callafter() {
      await this.getbranchlocation()
    },
    getbranchlocation() {
      var vm = this
      return new Promise((resolve) => {
        axios
          .get(
            config.getConfig('serverUrl') +
              'branchlocation?pageid=' +
              this.pageid
          )
          .then((response) => {
            if (response.data.responsecode == 200) {
              vm.branchlocation = response.data.branchlocation
              let externalScript = document.createElement('script')
              externalScript.setAttribute(
                'src',
                `https://maps.googleapis.com/maps/api/js?key=${response.data.googlekey}&language=th&libraries=places`
              )
              externalScript.async = true
              externalScript.defer = true
              externalScript.onload = () => {
                vm.showmap = true
                resolve()
              }
              document.head.appendChild(externalScript)
              // resolve();
            }
          })
      })
    },
    calshippingprice(distance_km, totalprice) {
      //   var ceiling_distance_km = Math.ceil(distance_km);
      try {
        var ceiling_distance_km = 0
        var decimal = parseFloat((distance_km % 1).toFixed(1))
        distance_km = Math.floor(distance_km)
        if (decimal > 0.4) distance_km += 1
        ceiling_distance_km += distance_km
      } catch (error) {
        return false
      }

      var pizzaProducts = this.cart.filter((el) => {
        return el.categoryid == 13119
      })

      var amazonProducts = this.cart.filter((el) => {
        return el.categoryid == 13118
      })

      var hasAmazon = amazonProducts.length > 0
      var hasPizza = pizzaProducts.length > 0

      var totalAmazon = 0
      if (amazonProducts.length > 0)
        totalAmazon = amazonProducts.reduce((pre, cur) => {
          return pre + cur.price
        })

      var amazon = 0
      var pizza = 0

      switch (ceiling_distance_km) {
        case 0:
        case 1:
        case 2:
          pizza = hasPizza ? 20 : 0
          amazon = hasAmazon && totalAmazon >= 200 ? 0 : 20

          break
        case 3:
          pizza = hasPizza ? 25 : 0
          amazon = hasAmazon ? 25 : 0
          break
        case 4:
          pizza = hasPizza ? 30 : 0
          amazon = hasAmazon ? 30 : 0
          break
        case 5:
          pizza = hasPizza ? 35 : 0
          amazon = hasAmazon ? 35 : 0
          break
        case 6:
          pizza = hasPizza ? 40 : 0
          amazon = hasAmazon ? 40 : 0
          break
        case 7:
          pizza = hasPizza ? 47 : 0
          amazon = hasAmazon ? 47 : 0
          break
        case 8:
          pizza = hasPizza ? 54 : 0
          amazon = hasAmazon ? 54 : 0
          break
        case 9:
          pizza = hasPizza ? 61 : 0
          amazon = hasAmazon ? 61 : 0
          break
        case 10:
          pizza = hasPizza ? 68 : 0
          amazon = hasAmazon ? 68 : 0
          break

        default:
          var over_fee = (ceiling_distance_km - 10) * 10
          pizza = hasPizza ? 68 + over_fee : 0
          amazon = hasAmazon ? 68 + over_fee : 0
      }

      return {
        total: pizza + amazon,
        pizza: pizza,
        amazon: amazon
      }
    },
    gmapLocation(coords) {
      var vm = this
      var locations = []
      var nearestlocation
      var stringlatlng =
        this.gmapvalue.lat.toString() + ',' + this.gmapvalue.lng.toString()
      var service = new google.maps.DistanceMatrixService()
      var origins = vm.branchlocation.map((el) => el.lat_long)

      service.getDistanceMatrix(
        {
          origins,
          destinations: [stringlatlng],
          travelMode: 'DRIVING',
          region: 'TH',

          drivingOptions: {
            departureTime: new Date(),
            trafficModel: 'optimistic'
          }
        },
        callback
      )
      function callback(response, status) {
        if (status == 'OK') {
          var bodyjson = response
          for (var i = 0; i < bodyjson.rows.length; i++) {
            var row = bodyjson.rows[i].elements[0].distance

            try {
              locations.push({
                name: vm.branchlocation[i].name,
                distance: parseFloat((row.value / 1000).toFixed(2)),
                pictureurl: vm.branchlocation[i].pictureurl
              })
            } catch (error) {
              console.error(error)
            }
          }

          locations.sort((a, b) => {
            var x = a.distance
            var y = b.distance
            return x < y ? -1 : x > y ? 1 : 0
          })

          nearestlocation = locations[0]
          vm.shippingAddress = response.destinationAddresses[0]
          vm.placesinfo = response.destinationAddresses[0]
          vm.shippingdistance = nearestlocation
          var shippingprice = vm.calshippingprice(
            nearestlocation.distance,
            vm.totalincludediscount
          )

          vm.fastdelishippingprice = shippingprice
          vm.ableToShipping = shippingprice !== false
          vm.customShippingFee = vm.ableToShipping ? shippingprice.total : 0

          if (vm.branchlocation && vm.branchlocation.length > 1) {
            vm.banktransferinfo_photo = nearestlocation.pictureurl
          } else {
            vm.banktransferinfo_photo = vm.mainBankTransferInfoPhoto
          }
          //   vm.khaiwhanselectedbank = vm.khaiwhanbank.find((el) => el.ref == nearestlocation.name);
        } else {
          // 400
        }
      }
    },
    handleSubmit: async function () {
      let vm = this
      var result = await vm.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        vm.goToErrorInput()
        return false
      }
      if (vm.isEmptyShoppingCart) {
        return false
      }
      vm.loading = true
      var pizzaProducts = this.cart.filter((el) => {
        return el.categoryid == 13119
      })

      var amazonProducts = this.cart.filter((el) => {
        return el.categoryid == 13118
      })

      var pizzadata =
        pizzaProducts.length > 0
          ? vm.formatOrderRequest(
              pizzaProducts,
              this.fastdelishippingprice.pizza,
              13119
            )
          : null
      var amazondata =
        amazonProducts.length > 0
          ? vm.formatOrderRequest(
              amazonProducts,
              this.fastdelishippingprice.amazon,
              13118
            )
          : null

      try {
        var pizzaresponse = null
        if (pizzaProducts.length > 0)
          pizzaresponse = await this.submitOrder(pizzadata)

        var amazonresponse = null
        if (amazonProducts.length > 0)
          amazonresponse = await this.submitOrder(amazondata)

        // JSON responses are automatically parsed.
        var response = pizzaresponse ? pizzaresponse.data : amazonresponse.data
        if (response.responsecode == 200) {
          if (pizzadata.payment == '2c2p' && vm.isCDS) {
            vm.orderid = response.orderid
            vm.amount = pizzadata.total
            this.$nextTick(() => {
              vm.submit2c2p()
            })
          } else {
            vm.isCompleted = true
            vm.$store.dispatch('deleteAllItemsInCart')
            // eslint-disable-next-line
            if (vm.$liff.isInClient()) {
              // eslint-disable-next-line no-undef
              vm.$liff
                .sendMessages([
                  {
                    type: 'text',
                    text: 'Order: ' + response.orderid
                  }
                ])
                .then(() => {})
              // eslint-disable-next-line no-undef
              vm.$liff.closeWindow()
            } else {
              // eslint-disable-next-line no-undef
              MessengerExtensions.requestCloseBrowser(
                function success() {},
                function error() {
                  window.close()
                }
              )
            }
          }
        } else if (response.responsecode == 400) {
          this.isCompleted = true
          await this.$store.dispatch('deleteAllItemsInCart')
          // eslint-disable-next-line
          if (this.$liff.isInClient()) {
            // eslint-disable-next-line no-undef
            await this.$liff.sendMessages([
              {
                type: 'text',
                text: 'Order: ' + response.orderid
              }
            ])
            // eslint-disable-next-line no-undef
            await this.$liff.closeWindow()
          } else {
            // eslint-disable-next-line no-undef
            MessengerExtensions.requestCloseBrowser(
              function success() {},
              function error() {
                window.close()
              }
            )
          }
        } else if (response.responsecode == 201) {
          vm.isCompleted = true
          vm.$store.dispatch('deleteAllItemsInCart')
          let url = '/ecommerce/' + vm.pagename
          if (vm.userid && vm.userid != null && vm.userid != '') {
            url += '?userid=' + vm.userid
          }
          vm.$router.push({ path: url })
        } else {
          vm.$swal({
            title: vm.$t('Error'),
            text: vm.$t('Something went wrong. Please try it again..'),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('Cancel'),
            reverseButtons: true
          })
        }
        vm.loading = false
      } catch (error) {
        console.error(error)
        vm.loading = false
        vm.$swal({
          title: vm.$t('Error'),
          text: vm.$t('Something went wrong. Please try it again.'),
          type: 'error',
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('Cancel'),
          reverseButtons: true
        })
      }
    },
    async submitOrder(data) {
      let url = config.getConfig('serverUrl') + 'banktransfernotify'

      if (this.sessiontoken != null || this.sessiontoken != '') {
        url += '?sessiontoken=' + this.sessiontoken
      }
      if (this.$route.query.from) {
        data.from = this.$route.query.from
      } else {
        try {
          var device = this.$liff.getOS()
          var version = this.$liff.getVersion()
          await this.$liff.ready

          if (
            this.userid.indexOf('__') != -1 &&
            device &&
            version &&
            !this.$liff.isInClient()
          ) {
            data.from = 'livechat'
          }
        } catch (error) {
          // eslint-disable-next-line
          console.log(error)
        }
      }
      data.cart_ids = this.$store.state.cart_ids || []
      var response = await axios.post(url, data)
      return Promise.resolve(response)
    },
    formatOrderRequest(products, shippingFee, categoryid) {
      var total = products
        .map((el) => {
          return el.price
        })
        .reduce((prev, curr) => {
          return prev + curr
        })
      var shippingCharge = 0
      if (shippingFee) {
        shippingCharge = shippingFee
        total += shippingCharge
      }
      var payment
      if (this.transferType) {
        payment = this.transferType
      } else {
        payment = null
      }
      var note = this.paymentSlipImage

      this.shippingAddress

      var combine_address = ''
      combine_address = this.shippingAddress.replace(/,/g, '')
      if (
        !this.useOldAddress.includes(this.pageProfile.pageid) &&
        this.shippingAddress2.sub_district &&
        this.shippingAddress2.district &&
        this.shippingAddress2.province &&
        this.shippingAddress2.zipcode
      ) {
        var inBangkok = this.shippingAddress2.province == 'กรุงเทพมหานคร'
        combine_address =
          combine_address +
          ' , ' +
          [
            (inBangkok ? 'แขวง' : 'ตำบล') +
              this.shippingAddress2.sub_district.replace(/,/g, ''),
            (inBangkok ? 'เขต' : 'อำเภอ') +
              this.shippingAddress2.district.replace(/,/g, ''),
            'จังหวัด' + this.shippingAddress2.province.replace(/,/g, ''),
            this.shippingAddress2.zipcode.replace(/,/g, '')
          ].join(' , ')
      }

      let data = {
        amount: total.toFixed(2).toString().replace('.', ''),
        pageid: this.pageid,
        userid: this.userid,
        app: this.app,
        name: this.customerName,
        address: combine_address,
        phone: this.customerPhone,
        payment: payment,
        nameaddress:
          this.customerName.replace(/,/g, '') +
          ' , ' +
          combine_address +
          ' , ' +
          this.customerPhone.replace(/,/g, ''),
        shippingtype: this.shippingType ? this.shippingType.type : null,
        note: note,
        remark:
          this.pageProfile.type == 'monobo'
            ? this.remark + ';;' + this.bankname
            : this.remark,
        shippingcharge: shippingCharge.toFixed(2).toString().replace('.', ''),
        total: total.toFixed(2).toString().replace('.', ''),
        categoryid: categoryid
      }

      if (this.voucher) {
        data.promocode = this.voucher.promocode
      }
      if (this.sessiontoken != null || this.sessiontoken != '') {
        data.sessiontoken = this.sessiontoken
      }

      return data
    }
  }
}
</script>

<style lang="scss" scoped></style>
